import { Invoice } from '../types/payment'

/**
 * Calculate payment progress percentage for an invoice
 */
export const calculatePaymentProgress = (invoice: Invoice): number => {
  if (!invoice.total_amount || invoice.total_amount === 0) return 0
  const paidAmount = Number(invoice.paid_amount) || 0
  const totalAmount = Number(invoice.total_amount) || 0
  if (totalAmount === 0) return 0
  return Math.round(Math.min(100, (paidAmount / totalAmount) * 100))
}

/**
 * Check if an invoice is overdue
 */
export const isInvoiceOverdue = (dueDate: string, status: string): boolean => {
  return status !== 'paid' && status !== 'cancelled' && new Date(dueDate) < new Date()
}

/**
 * Get outstanding amount from invoice
 */
export const getOutstandingAmount = (invoice: Invoice): number => {
  return invoice.outstanding_amount || invoice.balance_amount || 0
}

/**
 * Format invoice date for display
 */
export const formatInvoiceDate = (date: string): string => {
  return new Date(date).toLocaleDateString('en-GB')
}

/**
 * Format currency amount in Indian Rupee format
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0)
}
